'use client';
import { useState, useEffect } from "react";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { Button } from "@mui/material";
import { getCachedData } from "api/Cache";
import EventsEmitter from "events/EventsEmitter";
import { CircularProgress } from "@mui/material";
import { CircularProgressWithLabel } from "components";
import AlertNotification from "components/AlertNotification";
import { refreshProjectsList } from 'store/main/userManagement';
import {useDispatch, useSelector} from 'react-redux';
import { RootState } from 'store';
import jwtService from 'services/jwtService';
import { allArrayChildren } from "services/UtilsService";
import {initialProjects} from "constants/common";
import { trackEvent } from "./Tracking";


type IUserProject = {
    name: string;
    id : string;
    access:string;
    project:string;
    userid:number
};

type IProject = {
    name: string;
    id : string;
};

type IMember = {
    member: string,
    project : string,
    accessLevel : string,
}

type TUser = {
    id: string,
    email : string
}

const UserProjects = (props : TUser) => {

    const dispatch = useDispatch();
    let selectedProjectsList = useSelector((state:RootState) => state.main.addMember.selectedProjectsList)
   
    const {id, email} = props
   
    const data = getCachedData();
    const [projectError, setProjectError] = useState(false);
    const [helperTextProject, setHelperTextProject] = useState("");
    const [projectSelected, setProjectSelected] = useState('')
    const [accessLevelError, setAccessLevelError] = useState(false);
    const [helperTextAccess, setHelperTextAccess] = useState("");
    const [addAcccessLevel, setAddAcccessLevel] = useState('');
    const [progress, setProgress] = useState(0);
    const [allProjects, setAllProjects] = useState<IProject[]>([])
    const [message, setMessage] = useState('');
    const [showSavedNotification, setShowSavedNotification] = useState(false)
    const [userProjects, setUserProjects] = useState<IUserProject[]>([])
    const [currentAccess, setCurrentAccess] = useState('');
    const [currentId, setCurrentId] = useState('');
	
    useEffect(() => {
        const handleProgress = (curProgress: number) => {
            setProgress(curProgress);
        };
        EventsEmitter.on("projects_progress", handleProgress);
        return () => {
            EventsEmitter.removeEventListener("projects_progress", handleProgress);
        };
      
    }, [data]);

    useEffect(() => {
        const projectsList = data["projects"];
        let projectTab: IProject[] = [];
        const keys = Object.keys(projectsList);
        keys.forEach((key, index)  => {
            projectTab.push({name:projectsList[key]['name'], id:projectsList[key]['ID']})
            if(index === keys.length - 1){
                setAllProjects(projectTab)
            }
        }) 
    }, [data]);


    if (!data.loaded) {
        return progress === 0 ? <CircularProgress /> : <CircularProgressWithLabel value={progress} />;
    }

    const handleProject = (e:any) => {
        setProjectSelected(e.target.value)
      
        if(e.target.value === ''){
            setProjectError(true);
            setHelperTextProject("Please select a project");
        }else{
            setProjectError(false);
            setHelperTextProject("");
        }
    }

    const handleAddLevel = (e:any) => {
        setAddAcccessLevel(e.target.value)
        if(e.target.value === ''){
            setAccessLevelError(true);
            setHelperTextAccess("Please select an access level");
        }else{
            setAccessLevelError(false);
            setHelperTextAccess("");
        }
    }

    const handleAccessLevel = (accessLevel:string, id:any, index:any) => {

        userProjects[index]['access'] = accessLevel
        //refreshData(id)
    
        setCurrentAccess(accessLevel)
        setCurrentId(id)
        //setAccessLevel(accessLevel)
        if(accessLevel === ''){
            setAccessLevelError(true);
            setHelperTextAccess("Please select an access level");
        }else{
            setAccessLevelError(false);
            setHelperTextAccess("");
        }
    }

    const refreshData = async (id:any) => {
        
        try{
            const endpoint = process.env.REACT_APP_BASE_URL + '/user/projects';
            let response = await jwtService.fetchRequest({
                method: 'POST',
                url: endpoint,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                data: {userid : id, key_id : process.env.REACT_APP_BASE_APIKEY}
            });

            let list:any = [];

            if(response.data){
                let result:any = [];

               
                allProjects.forEach((item) => {
                    result[item['id']] = item['name']
                })
            
                response.data.forEach((item:any) => {
                    list.push({id: item.id, userid:item.userid, project:item.project, access:item.access, name: result[item.project]});
                })
            }
            setUserProjects(list.filter((item:any) => item.access !== 'none'))
       
            dispatch(refreshProjectsList(list.filter((item:any) => item.access !== 'none')));

        }catch(e){
            console.log(e)
        }
    }

    const updateRemoteUserProject = async (elem:any) => {

         try{
            const endpoint = process.env.REACT_APP_BASE_URL + '/vf/update-project-level';
            let response = await jwtService.fetchRequest({
                method: 'POST',
                url: endpoint,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                data: {
                    email : elem.member, 
                    projectId : elem.project, 
                    access_level : elem.accessLevel,
                    key_id : process.env.REACT_APP_BASE_APIKEY
                }
            });

            if(response.data) {
                console.log(response.data + 'Assign project ' + elem.project + ' to user ' + elem.member + ' ...................')
            }
        }catch(e){
            console.log(e)
        }      
    }


    const saveUserProject = async (elem: IMember, settingId:any) => {
  
        if(elem.project === ''){
            setProjectError(true);
            setHelperTextProject("Please select a project");
            return false
        }

        if(elem.accessLevel === ''){
            setAccessLevelError(true);
            setHelperTextAccess("Please select an access level");
            return false;
        }
     
        try{
            const endpoint = process.env.REACT_APP_BASE_URL + '/customer/addproject';
            let response = await jwtService.fetchRequest({
                method: 'POST',
                url: endpoint,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                data: {userid : settingId, project: elem.project, access : elem.accessLevel, mode : 'created', key_id : process.env.REACT_APP_BASE_APIKEY}
            });

            if(response.data) {
                setMessage(response.data.msg)
                setShowSavedNotification(true)
                // setSaveLoading(false)
                //setShowAddProject(false)
                setAddAcccessLevel('')
                setProjectSelected('')
                refreshData(settingId)
                updateRemoteUserProject(elem)
                setTimeout(() => {
                    setShowSavedNotification(false)
                }, 5000);
            }
        }catch(e){
            console.log(e)
        }
    }

	return (
            <>
            {
                showSavedNotification ? 
                <AlertNotification variant={"standard"} type={"success"} message={message} />
                : ''
            }
                <TextField
                    required
                    autoFocus
                    fullWidth
                    id="project"
                    select
                    label="Project"
                    error={projectError}
                    helperText={helperTextProject}
                    value={projectSelected}
                    sx={{marginTop:'12px'}}
                    onChange={(e) => handleProject(e)}
                >
                    {
                        allProjects
                        .filter(elem => !initialProjects.includes(elem.id))
                        .map(item => <MenuItem value={item.id} key={item.id}>{item.name}</MenuItem>)
                    }
                </TextField>

                <TextField
                    required
                    fullWidth
                    id="access-level"
                    select
                    label="Access level" 
                    error={accessLevelError}
                    helperText={helperTextAccess}
                    value={addAcccessLevel}
                    sx={{marginTop:'8px'}}
                    onChange={(e) => handleAddLevel(e)}
                >
                    <MenuItem value="read">Read-only</MenuItem>
                    <MenuItem value="full">Full control</MenuItem>
                </TextField>
                    
                <Button 
                    color="primary"
                    style={{ margin:"10px 0", display:'flex', marginLeft:'auto'}} 
                    variant="contained" 
                    onClick={() => {
                        trackEvent("UserProfile", "My Team", "Assign Project");
                        saveUserProject({"member":email, "project":projectSelected, "accessLevel":addAcccessLevel}, id);
                    }}>
                    Save
                </Button>
            </>    
  	    );
};

export { UserProjects };
